module.exports = __webpack_public_path__ + "static/media/7.89350b82.jpg";